import React from 'react';
import { SvgIcon } from '@components-library/Icons/SvgIcon';
import SuccessIcon from 'assets/icons/success-icon.svg';
import { IUploadFileInputPreviewProps } from './types';

export const UploadFileInputPreview = (props: IUploadFileInputPreviewProps): JSX.Element => {
  const { imagePreviewUrl, value, preattachedFile } = props;

  return (
    <>
      {value && preattachedFile && !value.preview && <SvgIcon src={SuccessIcon} className="form__input-preattached" />}
      <img className="form__input-preview" src={imagePreviewUrl} alt="" /> {value.name || value.fileName}
    </>
  );
};
